import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
@Component({
  selector: "app-plus-animation-mobile",
  templateUrl: "./plus-animation-mobile.component.html",
  styleUrls: ["./plus-animation-mobile.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlusAnimationMobileComponent {
  @Input() property1:
  | "Hover"
  | "Default"
  | "Check"
  | "Disabled"
  | "Without interaction"
  | "Check Hover" = "Check";
  @Input() state = 'Active'
}
